// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1702":"4d34c113","7222":"18394c63","7937":"de4f6177"}[chunkId] || chunkId) + "." + {"1702":"c2239eeace4f8da1","5763":"37be656412518543","7222":"0f37f9ce53937861","7937":"6d91f6cd5628fa36"}[chunkId] + ".js";
};